import { render, staticRenderFns } from "./JettonStatsRows.vue?vue&type=template&id=ac4fe458"
import script from "./JettonStatsRows.vue?vue&type=script&lang=js"
export * from "./JettonStatsRows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports